import createDebounce from 'redux-debounced';
import thunk from 'redux-thunk';
import { useDispatch } from 'react-redux';

import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from 'redux/reducers/rootReducer';

const middlewares = [thunk, createDebounce()];
let composeEnhancers = compose;

const reduxDevtoolsExtensionCompose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
if (reduxDevtoolsExtensionCompose) {
  composeEnhancers = reduxDevtoolsExtensionCompose({
    trace: false,
    traceLimit: 25,
  });
}
const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middlewares)));

// TODO fix for thunks
// export type AppDispatch = typeof store.dispatch;
// export const useAppDispatch: () => AppDispatch = useDispatch;
export type AppDispatch = any;
export const useAppDispatch: () => AppDispatch = useDispatch;

export { store };
